export default __webpack_public_path__ + "static/media/22.61d7a13b.png";